"use client"

import { ReactNode, useEffect, useState, PropsWithChildren } from "react"
import { useAuth } from "react-oidc-context"
import { LOCAL_AGENT } from "@/lib/localDev"
import { LoginScreen } from "./LoginScreen"
import { BrandLoader } from "@/components/ai-elements/loader"

function AutoSigninContent({ children }: PropsWithChildren) {
  const auth = useAuth()

  // Local mode: no Cognito login — the local agent shim does not validate
  // tokens, so render the app straight through without a sign-in gate.
  if (LOCAL_AGENT) {
    return <>{children}</>
  }

  if (auth.isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <BrandLoader label="Cargando…" />
      </div>
    )
  }

  if (!auth.isAuthenticated) {
    return <LoginScreen onSignIn={() => auth.signinRedirect()} />
  }

  return <>{children}</>
}

export function AutoSignin({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return null
  }

  return <AutoSigninContent>{children}</AutoSigninContent>
}
